export function setStorageValue<T>(key: string, value: T) {
  localStorage.setItem(
    key,
    typeof value !== 'string' ? JSON.stringify(value) : value
  );
}
